module.exports = __webpack_public_path__ + "static/cover-24a396b83a9a475701ed5b494fe6ae50.png";